// extracted by mini-css-extract-plugin
export default {"imgBox":"imgBlock_imgBox__x1+L2","imgBlock":"imgBlock_imgBlock__pe8Xv","img_bg":"imgBlock_img_bg__50bpe"};